"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LineChart = require("./LineChart");
Object.keys(_LineChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LineChart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LineChart[key];
    }
  });
});